import { group } from 'console';
import api from '../services/api';

export const loadData = async (
  setChartData: any,
  addToast: any,
  selectedSensorId: string,
  initialDate: string,
  finalDate: string,
  max: number,
  value_type: 'acumulado' | 'minimomaximo' | 'instantaneo',
  group_by: 'dia' | 'hora' | 'semana' | 'mes' | 'nenhum',
  setLoading?: any,
) => {
  setLoading && setLoading(true);

  try {
    const { data } = await api.get(`sensorData/dashboard`, {
      params: { sensor_id: selectedSensorId, date: initialDate, final_date: finalDate, max, value_type, group_by },
    });
    setChartData(data);

  } catch (error) {
    addToast({
      type: 'error',
      title: 'Erro ao buscar pesquisar por essa data!',
      description: `${error}`,
    });
  } finally {
    setLoading && setLoading(false);
  }
};
